import { render } from "./PcDetails.vue?vue&type=template&id=f0cf1cba"
import script from "./PcDetails.vue?vue&type=script&lang=js"
export * from "./PcDetails.vue?vue&type=script&lang=js"

import "./PcDetails.vue?vue&type=style&index=0&id=f0cf1cba&scope=true&lang=css"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__